<template>
  <div>
    <!-- 부가정보 : 안전작업허가서 정보-->
    <div>
      <h5 class="mb-4"><i class="dot"></i> 안전작업허가서 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>공장명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.공장명" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>작업기간</div>
          <date-selector-rang :readonly="readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.작업기간" />
        </div>
        <div>
          <div>공사금액</div>
          <div class="flex items-center justify-center gap-3">
            <NumberInput :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.공사금액" class="flex-1" />
            <span>원</span>
          </div>
        </div>
        <div>
          <div>작업업체명</div>
          <div v-if="isPrint" class="print-input">{{ form.안전작업허가서정보.작업업체명 && form.안전작업허가서정보.작업업체명.com_name? form.안전작업허가서정보.작업업체명.com_name : ''}}</div>
          <company-selector
            v-else
            :readonly="board.readonly"
            v-model="form.안전작업허가서정보.작업업체명.id"
            :company-name="form.안전작업허가서정보.작업업체명.com_name"
            @select="(company) => (form.안전작업허가서정보.작업업체명 = company)"
          />
        </div>
        <div>
          <div>작업자</div>
          <div class="flex items-center justify-center gap-3">
            <NumberInput :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.작업자" class="flex-1" />
            <span>명</span>
          </div>
        </div>
        <div>
          <div class="flex items-center">
            <p>산업안전관리비(계상금액)</p>
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="info-icon" @click="popup산업안전관리비 = true" />
          </div>
          <div class="flex items-center justify-center gap-3">
            <NumberInput :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.산업안전관리비" class="flex-1" />
            <span>원</span>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>작업구역</div>
          <div v-if="isPrint">
            <div class="print-input">{{ form.안전작업허가서정보._작업구역.region && form.안전작업허가서정보._작업구역.region.name }}</div>
            <div class="print-input">{{ form.안전작업허가서정보._작업구역.zone && form.안전작업허가서정보._작업구역.zone.name }}</div>
          </div>
          <region-selector v-else ref="region" v-model="form.안전작업허가서정보._작업구역">
            <template #custom>
              <!-- 본사선택시 수동기입란 생성 -->
              <ml-input
                v-if="form.안전작업허가서정보._작업구역.region.id && form.안전작업허가서정보._작업구역.region.id === 5 && form.안전작업허가서정보._작업구역.zone.id"
                :disabled="readonly || !(form.안전작업허가서정보._작업구역.region ? form.안전작업허가서정보._작업구역.region.id : false)"
                v-model="form.안전작업허가서정보._작업구역수동입력"
              />
            </template>
          </region-selector>
        </div>
        <div class="writeGridLineItem">
          <div>공사/작업명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.공사작업명" />
        </div>
        <div class="writeGridLineItem">
          <div>세부 작업내용</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업허가서정보.세부작업내용" />
        </div>
      </div>
    </div>

    <!-- 부가정보 : 보험 자료 확인사항-->
    <write-grid-container title="보험 자료 확인사항" v-model="form.보험자료확인사항" :options="보험자료확인사항Options" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div v-if="form.보험자료확인사항[value]" class="print-input">{{ form.보험자료확인사항[value].fileName }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <file-uploader :readonly="readonly" v-model="form.보험자료확인사항[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 부가정보 : 안전관계자-->
    <div class="mt-28px">
      <div class="flex flex-wrap justify-between items-center">
        <h5 class="mb-4"><i class="dot"></i> 안전관계자</h5>
        <div class="mb-4 flex ml-auto">
          <vs-button class="mr-2" color="secondary" @click="addSafetyManager">공사업체 인원 추가</vs-button>
          <vs-button color="secondary" type="border" @click="removeSafetyManager">마지막 행삭제</vs-button>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>동국제강</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.동국제강.name }}</p>
          <member-selector
            v-else
            v-model="form.안전관계자.동국제강.id"
            :member-name="form.안전관계자.동국제강.name"
            popup-type="user"
            @select="
              (member) => {
                form.안전관계자.동국제강 = member;
                if (!form.안전관계자.동국제강.phone) form.안전관계자.동국제강.phone = '';
              }
            "
          />
        </div>
        <div>
          <div>전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.동국제강.phone }}</p>
          <ml-input v-else class="w-full" readonly :value="formatPhone(form.안전관계자.동국제강.phone)" />
        </div>
      </div>

      <div class="writeGridContainer" style="margin-bottom: 0.625rem; padding-top: 0.625rem" v-for="(contractor, idx) in form.안전관계자.공사업체" :key="idx">
        <div>
          <div>공사업체</div>
          <p v-if="isPrint" class="print-input">{{ contractor.name }}</p>
          <member-selector
            v-else
            v-model="contractor.id"
            :member-name="contractor.name"
            popup-type="user"
            @select="
              (member) => {
                form.안전관계자.공사업체[idx] = member;
                if (!form.안전관계자.공사업체[idx].phone) form.안전관계자.공사업체[idx].phone = '';
              }
            "
          />
        </div>
        <div>
          <div>전화번호</div>
          <p v-if="isPrint" class="print-input">{{ contractor.phone }}</p>
          <ml-input v-else class="w-full" readonly :value="formatPhone(contractor.phone)" />
        </div>
      </div>
    </div>

    <!-- 참고사항 -->
    <table class="mt-4 mb-12">
      <thead>
        <tr>
          <th>참고사항</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ol style="list-style: auto; font-size: 14px; padding: 0 16px" class="font-medium text-left">
              <li>관리책임은 공사담당으로 안전작업허가서 승인자가 작업안전관리자가 되며, 신청부서의 부서장이 안전책임자가 된다.</li>
              <li>근재(단체)보험은 보상한도액이 1인당 5억원 이상, 1사고당 5억원 이상이어야 하며, 보험증권을 확인해야한다.</li>
              <li>
                신청자는 아래 필수서식을 작성, 작업 3일전까지 신청, 허가를 득하여야 하며 미허가시는 당해 작업이 제한될 수 있다.
                <ul class="font-normal">
                  <li>[동국제강 필수서식] 공사시방서</li>
                  <li>[업체 필수서식] 각서, 산재/근재보험, 작업환경측정, 위험성평가, 안전보건관리비사용계획서, 공정별 안전대책, 건설업 기초안전보건교육 이수증</li>
                  <li>[업체 추가서식] 안전협의체 회의록, 물질안전보건자료(GHS-MS DS), 중량물취급계획서, 차량게하역운반기계 계획서, 유해위험방지계획서, 재해예방 기술지도계약서</li>
                </ul>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 공사인원 -->
    <h5 class="mb-4"><i class="dot"></i> 공사인원</h5>
    <div style="font-size: 14px" class="font-medium">
      ※안내
      <ol style="list-style: auto; padding: 0 16px" class="text-left">
        <li>
          출입자 변동시 수정등록 및 각 공장 안전 staff로 통보할 것
          <br />- 인천공장 : 032-830-6247 / 포항공장 : 054-721-3232 / 당진공장 : 041-351-4621 / 중앙기술연구소 : 054-271-2715
        </li>
        <li>인원이 늘어날 경우 ‘항목추가’버튼을 이용하여 계속 추가할 수 있습니다.</li>
      </ol>
    </div>
    <table-custom
      :board="{ readonly: readonly }"
      controls
      customAddHandler
      :default-size="0"
      :min-size="0"
      buttonAddName="사용자 검색"
      :is-print="isPrint"
      :tableData="[
        { id: 'No.', title: 'No.', type: 'no', width: 64 },
        { id: '성명', title: '성명', type: 'customType', width: 164 },
        { id: '직위', title: '직위(직책)', type: 'select', width: 164, selectData: ['안전전담자', '관리감독자', '신호수', '화재감시자', '작업자'] },
        { id: '생년월일', title: '생년월일(6자리)', type: 'customType', width: 164 },
        { id: '기초안전보건교육수료증', title: '건설업 기초안전보건교육 수료증', type: 'file', width: 164, readonly: true },
      ]"
      v-model="form.공사인원Table"
    >
      <template #buttons="{ handleAddButton, handleRemoveButton, checkData }">
        <div class="flex justify-end gap-2">
          <AlertUserSelector ref="refUserSelector" class="w-full" v-model="selectedUser" :disabledCheckUserIds="공사인원TableUserIds" :readonly="readonly" style="display: none" fullData @select="onSelectUsers" />
          <vs-button color="secondary" @click="$refs.refUserSelector.onClickOpenPopup()">항목추가</vs-button>
          <vs-button @click="() => remove공사인원Table(handleRemoveButton)" color="secondary" type="border" :disabled="checkData.length === 0">선택삭제</vs-button>
        </div>
      </template>
      <template #customType="{ index, label, value, id }">
        <div v-if="id === '성명'">
          <member-selector
            v-if="!isPrint"
            :readonly="readonly"
            popup-type="user"
            v-model="form.공사인원Table[index].성명.id"
            :member-name="form.공사인원Table[index].성명.name"
            :disabledUserIds="공사인원TableUserIds"
            @select="(user) => onSelectUser(index, user)"
          />
          <div v-else class="print-input">{{ form.공사인원Table[index].성명.name }}</div>
        </div>
        <div v-else-if="id === '생년월일'">
          <ml-input v-if="!isPrint" :readonly="true" v-model="form.공사인원Table[index].생년월일" />
          <div v-else class="print-input">{{ form.공사인원Table[index].생년월일 }}</div>
          <p v-if="check65old(form.공사인원Table[index].생년월일)" class="mt-1" style="font-weight: 400; font-size: 12px; line-height: 17px; text-align: left; color: #ea5455">만 65세 이상 작업자입니다.</p>
        </div>
      </template>
    </table-custom>

    <!-- 공사인원 -->
    <div class="mt-7">
      <div class="writeGridContainer">
        <div>
          <div>총 인원</div>
          <ml-input readonly :isPrint="isPrint" :value="form.공사인원.총인원" />
        </div>
        <div>
          <div>업체 비상연락처</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.공사인원.업체비상연락처" />
        </div>
        <div v-if="has65세">
          <div>DKS 발주부서장 확인서</div>
          <file-uploader v-model="form.공사인원.DKS발주부서장확인서" :readonly="board.readonly" class="w-full" />
        </div>
      </div>
      <div class="writeGridLineItem mt-4">
        <div class="fit-text mb-1">출입/작업시 필수 안전조치</div>
        <p v-if="isPrint" class="print-input">{{ form.출입작업시필수안전조치 }}</p>
        <div v-else class="flex items-center h-full">
          <!-- 동의서 -->
          <div class="flex items-center gap-2 cursor-pointer" @click="checkConfirm">
            <img v-if="form.출입작업시필수안전조치" src="@/assets/icons/checked_on.svg" class="check" />
            <img v-else src="@/assets/icons/checked_off.svg" class="check" />
            <p class="flex-1">(필수확인)</p>
          </div>
        </div>
      </div>
    </div>

    <Popup산업안전관리비기준표 v-model="popup산업안전관리비" />
    <popup필수안전조치동의서 v-model="popup필수안전조치동의서" :check="form.출입작업시필수안전조치" @update:check="form.출입작업시필수안전조치 = $event" />
  </div>
</template>

<script>
import { formatPhone } from "@/util/DataUtil";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";

import NumberInput from "@/components/NumberInput.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import FileUploader from "@/components/FileUploader.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import TableCustom from "@/components/TableCustom.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import RegionSelector from "@/components/selector/RegionSelector.vue";

import Popup산업안전관리비기준표 from "./Popup산업안전관리비기준표.vue";
import Popup필수안전조치동의서 from "@/views/boards/single-page/845/Popup필수안전조치동의서.vue";

export default {
  components: {
    Popup필수안전조치동의서,
    RegionSelector,
    MemberSelector,
    CompanySelector,
    WriteGridContainer,
    AlertUserSelector,
    NumberInput,
    CustomOptionSelector,
    FileUploader,
    DateSelectorRang,
    TableCustom,
    Popup산업안전관리비기준표,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      popup산업안전관리비: false,
      popup필수안전조치동의서: false,
      selectedUser: [],
      isSetSelectUser: false,

      보험자료확인사항Options: {
        labels: ["산재보험 서류", "근재보험서류 (필요시)", "안전보건관리계획서"],
        values: ["산재보험서류", "근재보험서류", "안전보건관리계획서"],
      },
      form: this.value,
    };
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
    공사인원TableUserIds() {
      return this.form.공사인원Table.map((_user) => _user.userId);
    },
    has65세() {
      return (
        this.form.공사인원Table.filter((data) => {
          const 생년월일 = data.생년월일;
          let is65 = false;
          if (생년월일) {
            const currentYear = new Date().getFullYear();
            const currentCentury = Math.floor(currentYear / 100) * 100; // 현재 세기의 시작 (예: 2000, 1900)
            let birthYear = parseInt(생년월일.substring(0, 2), 10);
            birthYear += birthYear <= currentYear % 100 ? currentCentury : currentCentury - 100;
            const age = currentYear - birthYear - 1;
            is65 = age >= 65;
          }
          return is65;
        }).length > 0
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form = value;
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);

        // selectedUser에 form의 데이터를 넣어준다.
        if (this.postId && this.form.공사인원Table.length > 0 && !this.isSetSelectUser) {
          this.isSetSelectUser = true;
          this.selectedUser = this.form.공사인원Table.map((_user) => {
            return { id: _user.userId };
          });
        }
      },
    },
  },
  created() {
    this.form.보험자료확인사항 = this.보험자료확인사항Options.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});
  },
  methods: {
    formatPhone,
    validate() {
      if (!this.form.안전작업허가서정보.공장명) return "안전작업허가서정보의 공장명을 입력해주세요.";
      else if (!this.form.안전작업허가서정보.작업기간.sDate || !this.form.안전작업허가서정보.작업기간.eDate) return "안전작업허가서정보의 작업기간을 입력해주세요.";
      else if (!this.form.안전작업허가서정보.공장명) return "안전작업허가서정보의 공장명을 입력해주세요.";
      else if (!this.form.안전작업허가서정보.공사금액) return "안전작업허가서정보의 공사금액을 입력해주세요.";
      else if (!this.form.안전작업허가서정보.작업업체명) return "안전작업허가서정보의 작업업체명을 입력해주세요.";
      else if (!this.form.안전작업허가서정보.작업자) return "안전작업허가서정보의 작업자를 입력해주세요.";
      else if (!this.form.안전작업허가서정보.산업안전관리비) return "안전작업허가서정보의 산업안전관리비를 입력해주세요.";
      else if (!this.form.안전작업허가서정보._작업구역.region.id || !this.form.안전작업허가서정보._작업구역.zone.id) return "안전작업허가서정보의 작업구역을 선택해주세요.";
      else if (!this.form.안전작업허가서정보.공사작업명) return "안전작업허가서정보의 공사작업명을 입력해주세요.";
      else if (!this.form.안전작업허가서정보.세부작업내용) return "안전작업허가서정보의 세부작업내용을 입력해주세요.";
      else if (!this.form.보험자료확인사항.산재보험서류.id) return "보험자료확인사항의 산재보험서류를 입력해주세요.";
      // else if (!this.form.보험자료확인사항.근재보험서류.id) return "보험자료확인사항의 근재보험서류를 입력해주세요.";
      else if (!this.form.보험자료확인사항.안전보건관리계획서.id) return "보험자료확인사항의 안전보건관리계획서를 입력해주세요.";
      else if (!this.form.안전관계자.동국제강.id) return "안전관계자의 동국제강 관계자를 입력해주세요.";
      else if (!this.form.안전관계자.공사업체[0].id) return "안전관계자의 공사업체 관계자를 입력해주세요.";
      else if (this.form.공사인원Table.length === 0) return "공사인원을 추가해주세요.";
      else if (!this.form.공사인원.업체비상연락처) return "공사인원의 업체비상연락처를 입력해주세요.";
      else if (!this.form.출입작업시필수안전조치) return "출입작업시 필수안전조치를 체크해주세요.";
    },
    set작업구역(fieldName) {
      if (fieldName.includes("당진공장")) {
        this.$refs.region.setRegionWithName("당진공장").zone.name;
      } else if (fieldName.includes("포항공장")) {
        this.$refs.region.setRegionWithName("포항공장").zone.name;
      } else if (fieldName.includes("인천공장")) {
        this.$refs.region.setRegionWithName("인천공장").zone.name;
      }
    },
    addSafetyManager() {
      this.form.안전관계자.공사업체.push({ id: 0, name: "", phone: "" });
    },
    removeSafetyManager() {
      if (this.form.안전관계자.공사업체.length < 2) return;

      this.form.안전관계자.공사업체.pop();
    },
    converterUserDate(user) {
      const metas = this.transformToMeta(user.metas);
      return {
        // 공통데이터
        id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        userId: user.id,
        userName: user.name,
        성명: {
          id: user.id,
          name: user.name,
        },
        직위: "",
        연락처: user.mobile || user.phone,
        생년월일: metas.rrn ? `${metas.rrn}`.padStart(7, "0").slice(0, -1) : "", // 간혹 rrn 을 받아올때 앞자리수가 0인경우에 값을 받아오지 못하는 경우를 대비
        우편번호: user.home_zip,
        기초안전보건교육수료증: metas.건설업기초안전교육 || {},
        건설기계조종사면허번호: metas.건설기계조종사면허번호,
        is_foreigner: metas.is_foreigner,
      };
    },
    onSelectUser(index, user) {
      this.form.공사인원Table[index] = this.converterUserDate(user);
    },
    onSelectUsers(users) {
      this.selectedUser = users;

      // this.form.공사인원Table 항목 중에서, users[*].id 가 없는 항목을 제거합니다.
      this.form.공사인원Table = this.form.공사인원Table.filter((item) => users.map((user) => user.id).includes(item.userId));

      // users[*].id 가 localValue[*].userId 에 없는 항목을 추가합니다.
      users.forEach((user) => {
        if (!this.form.공사인원Table.map((item) => item.userId).includes(user.id)) {
          this.form.공사인원Table.push(this.converterUserDate(user));
        }
      });
      this.update공사총인원();
    },
    remove공사인원Table(rmFunc) {
      rmFunc();
      this.update공사총인원();
      this.$nextTick(() => {
        this.selectedUser = this.form.공사인원Table.map((_user) => {
          return {
            id: _user.userId,
          };
        });
      });
    },
    update공사총인원() {
      this.$nextTick(() => {
        this.form.공사인원.총인원 = this.form.공사인원Table.length;
      });
    },
    checkConfirm() {
      this.popup필수안전조치동의서 = true;
    },

    transformToMeta(metas) {
      const meta = {};

      metas.forEach(({ meta_key, meta_value }) => {
        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },

    check65old(birth) {
      // 65세 이상
      // 간혹 rrn(6자리, YYMMDD{gender}) 을 받아올때 앞자리수가 0인경우에 값을 받아오지 못하는 경우를 대비
      const 생년월일 = birth ? `${birth}`.padStart(6, "0") : "";
      let err65 = false;
      if (생년월일) {
        const currentYear = new Date().getFullYear();
        const currentCentury = Math.floor(currentYear / 100) * 100; // 현재 세기의 시작 (예: 2000, 1900)
        let birthYear = parseInt(생년월일.substring(0, 2), 10);
        birthYear += birthYear <= currentYear % 100 ? currentCentury : currentCentury - 100;
        const age = currentYear - birthYear - 1;
        err65 = age >= 65;
      }
      return err65;
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    text-align: center;
    background: white;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    background: #f9f9f9;
    padding: 11px 0;
  }

  td {
    font-weight: 400;
    padding: 14px;
  }
}

.not-readlony-input::v-deep {
  input {
    background: white !important;
    cursor: pointer !important;
  }
}

.info-icon {
  color: #7e72f2;
  cursor: pointer;
}
</style>
